import { FC } from 'react';
import { useSelector } from 'react-redux';
import { InlineFilter } from 'shared/components/InlineFilter';
import { RangeInput } from 'shared/components/RangeInput';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectTotalArea } from 'shared/selectors/jsonQuery';

export const TotalAreaContainer: FC = () => {
  const { gte: valueMin = null, lte: valueMax = null } = useSelector(selectTotalArea);

  const onChange = useFilterChangeCallback();

  const handleMinValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setTotalAreaMin', arguments: [value] });
  });

  const handleMaxValueChange = useDebouncedCallback((value: number | null) => {
    onChange({ action: 'setTotalAreaMax', arguments: [value] });
  });

  return (
    <InlineFilter width={100} label="Общая" dataTestId="totalArea">
      <RangeInput
        min={1}
        max={9999}
        valueMin={valueMin}
        valueMax={valueMax}
        onChangeMin={handleMinValueChange}
        onChangeMax={handleMaxValueChange}
      />
    </InlineFilter>
  );
};
